// extracted by mini-css-extract-plugin
export default {"container":"_0lhhLcoswMKuWsan9EDc"};